document.addEventListener('turbo:before-render', () => {
  document.documentElement.style.scrollBehavior = 'auto'
})

document.addEventListener('turbo:load', () => {
  requestAnimationFrame(() => {
    document.documentElement.style.scrollBehavior = ''
  })
})
